module.exports = __webpack_public_path__ + "b79697dcf8da061abf9b3d75b4b2d9b6.svg";